export const ACTIVITIES_SEARCH_ACTIVITY_LOGS_REQUEST = "ACTIVITIES_SEARCH_ACTIVITY_LOGS_REQUEST";
export const ACTIVITIES_SEARCH_ACTIVITY_LOGS_RESULT = "ACTIVITIES_SEARCH_ACTIVITY_LOGS_RESULT";
export const ACTIVITIES_GET_ACCOUNTS_REQUEST = "ACTIVITIES_GET_ACCOUNTS_REQUEST";
export const ACTIVITIES_GET_ACCOUNTS_RESULT = "ACTIVITIES_GET_ACCOUNTS_RESULT";
export const ACTIVITIES_GET_TSO_ACCOUNTS_REQUEST = "ACTIVITIES_GET_TSO_ACCOUNTS_REQUEST";
export const ACTIVITIES_GET_TSO_ACCOUNTS_RESULT = "ACTIVITIES_GET_TSO_ACCOUNTS_RESULT";
export const ACTIVITIES_GET_USERS_REQUEST = "ACTIVITIES_GET_USERS_REQUEST";
export const ACTIVITIES_GET_USERS_RESULT = "ACTIVITIES_GET_USERS_RESULT";